import customAxios from './axios';
import CONFIG from '../../config';

export const getAll = () => {
    return customAxios.get(CONFIG.apiURL + '/TypingCenterStaffs').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllProcess = () => {
    return customAxios.get(CONFIG.apiURL + '/Processes').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getIndividual = (userID) => {
    return customAxios.get(CONFIG.apiURL + `/TypingCenterStaffs/${userID}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const create = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/TypingCenterStaffs/Create', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const update = (payload) => {
    return customAxios.put(CONFIG.apiURL + '/TypingCenterStaffs/Update', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllServices = () => {
    return customAxios.get(CONFIG.apiURL + '/TypingCenters/Services').then(res => {
        let response = res['data'];
        return response;
    });
};